import { useEffect, useContext, useState } from "react";

import { activateTrial, getBillingRedirect } from "../../../api";
import
{

  BannerContainer,
  CaptionContainer,
  CaptionText,
} from "./Licences.styles";
import { licenceTypes, licenceOptions } from "../../../options/licenceOptions";
import MainWrapper from "../../../components/Wrappers/MainWrapper/MainWrapper";
import Title from "../../../components/Typography/Title/Title";
import Banner from "../../../components/Alerts/Banner/Banner";
import StandardModal from "../../../components/Modals/StandardModal/StandardModal";
import SubscriptionNonPaymentForm from "../../../components/Forms/SubscriptionNonPaymentForm/SubscriptionNonPaymentForm";
import SubscriptionPaymentForm from "../../../components/Forms/SubscriptionPaymentForm/SubscriptionPaymentForm";
import StandardLink from "../../../components/Links/StandardLink/StandardLink";

// Contexts
import { BaseContext } from "../../../providers/Global/BaseProvider";
// import { LicencesContext } from "../../../providers/Index/LicencesProvider";
import SubscriptionCard from "../../../components/Cards/SubscriptionCard/SubscriptionCard";
import { routes } from "../../../options/routes";
import { Button, Stack, Typography, useMediaQuery } from "@mui/material";
import Index1Link from "../../../components/Links/Index1Link/Index1Link";
import { colors } from "../../../options/colors";
import { VerifiedOutlined } from "@mui/icons-material";
import { eliteLicenseFeatures } from "../../../options/features";

// API Calls

const EliteLicence = () =>
{
  // Collapse accordions when matches value changes
  const baseContext = useContext(BaseContext);
  // const licencesContext = useContext(LicencesContext);
  const [dataLoading, setDataLoading] = useState(true);
  const [licenceDetails, setLicenceDetails] = useState([]);
  const [activeLicences, setActiveLicences] = useState([]);
  const [selectedLicence, setSelectedLicence] = useState("");
  const [activeLicenceExpiry, setActiveLicenceExpiry] = useState(null);
  const [nonPaymentModalOpen, setNonPaymentModalOpen] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [modalLoading, setModalLoading] = useState(false);
  const [bannerError] = useState("");
  const [error, setError] = useState({
    show: false,
    message: "",
  });

  const isWide = useMediaQuery((theme) => theme.breakpoints.up('lg'));

  useEffect(() =>
  {
    if (
      !baseContext.baseData.loading
    )
    {
      setDataLoading(false);
      // setLicenceDetails(
      //   licencesContext.licencesData.licences.length > 0
      //     ? licenceOptions.filter((licence) => licence.id !== 1)
      //     : licenceOptions
      // );
      setLicenceDetails(licenceOptions)
      const date = new Date();
      setActiveLicenceExpiry(new Date(date.setDate(date.getDate() + 30)));
      setActiveLicences(baseContext.baseData.licences);
    }
  }, [baseContext]);

  const handleBannerClose = () =>
  {
    setError({
      show: false,
      message: "",
    });
  };

  const handleLicenceClick = async (type, freq, setRedirectLoading) =>
  {
    let response;
    let params = {
      success_url: document.location.href + "/success",
      cancel_url: document.location.href + "/error",
    };
    
    setSelectedLicence(type);
    params.subscription = (freq === "monthly") ? "index_elite_month" : "index_elite_year";
    params.success_url += "?success=" + params.subscription;
    response = await getBillingRedirect(params);
    document.location = response.data.url;
  };

  const handleNonPaymentModalClose = () =>
  {
    setNonPaymentModalOpen(false);
    setSelectedLicence("");
  };

  const handleNonPaymentModalSubmit = async () =>
  {
    await setModalLoading(true);
    let response = await activateTrial({});
    setError({
      show: false,
      message: `Successfully activated ${selectedLicence} Subscription`,
    });
    setModalLoading(false);
    handleNonPaymentModalClose();
    window.location.href = `${routes.home}`;
  };

  const handlePaymentModalClose = () =>
  {
    setPaymentModalOpen(false);
    setSelectedLicence("");
  };

  return (
    <>
      {
        <MainWrapper
          error={error.show}
          apiMessage={error.message}
          handleBannerClose={handleBannerClose}
          activeRoute={routes.indexLicences}
          clubLogo={baseContext.baseData.clubProfile.logo}
          dataLoading={dataLoading}
          hasEliteLicence={baseContext.baseData.hasEliteLicence}
          hasRezzilPlayerLicence={baseContext.baseData.hasRezzilPlayerLicence}
        >
          <Title text={"Elite Licence"} />
          {bannerError && (
            <BannerContainer>
              <Banner open={bannerError} text={bannerError} />
            </BannerContainer>
          )}
          {licenceDetails.length &&
            <Stack direction={isWide ? "row" : "column"} justifyContent="center" alignItems="center" spacing={4}>
              <SubscriptionCard
                key="index_elite_card"
                avatarBgColor={colors.primaryOrange}
                icon={<VerifiedOutlined />}
                title={`Elite Subscription`}
                features={eliteLicenseFeatures}
                isRecommended={false}
                isTrial={false}
                isEnabled={true}
                willRedirect={true}
                onClick={(freq) => handleLicenceClick(`Elite`, freq)}
                isExpired={false}
                isActive={baseContext.baseData.hasFullEliteLicense}
                showDowngrade={false}
              />
            </Stack>
          }
          {nonPaymentModalOpen && (
            <StandardModal
              open={nonPaymentModalOpen}
              onClose={handleNonPaymentModalClose}
              title={`${selectedLicence} Subscription`}
              btnText={"Cancel"}
              hideCancelBtn
            >
              <SubscriptionNonPaymentForm
                expiryDate={
                  selectedLicence === licenceTypes.trial
                    ? activeLicenceExpiry
                    : null
                }
                licence={licenceDetails.find(
                  (licence) => licence.title === selectedLicence
                )}
                loading={modalLoading}
                handleSubmit={handleNonPaymentModalSubmit}
              />
            </StandardModal>
          )}
          {paymentModalOpen && (
            <StandardModal
              open={paymentModalOpen}
              onClose={handlePaymentModalClose}
              title={`${selectedLicence} Subscription`}
              btnText={"Cancel"}
              hideCancelBtn
            >
              <SubscriptionPaymentForm
                licence={licenceDetails.find(
                  (licence) => licence.title === selectedLicence
                )}
              />
            </StandardModal>
          )}
        </MainWrapper>
      }
    </>
  );
};

export default EliteLicence;
